import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Component, Inject, OnInit, OnDestroy, ViewChild, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';

import { PARTYROLE, Region } from 'src/app/model/region.model';
import { County } from '../../../../model/county';
import { AppState } from 'src/app/reducers';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { DistrictDropdownComponent } from '../../../common-components/district/district-dropdown/district-dropdown.component';
import { DistrictEntityService } from 'src/app/component/common-components/service/district-entity.service';
import { CountyEntityService } from 'src/app/component/common-components/service/county-entity.service';
import { MsgModel } from '../../../common-components/msg/model/msg.model';
import { UserProfileService } from '../../../user-profile/service/user-profile.service';
import { User } from '../../../auth/model/user.model';
import { ApiSchoolDistrictsService } from 'src/app/service/api-school-districts.service';
import { OrganizationService } from '../../../common-components/organizations/service/organization.service';
import { ORGANIZATION } from 'src/app/model/school.model';
import { Observable, Subject } from 'rxjs'; // filter, debounceTime, map, Subscription, takeUntil
import Swal from 'sweetalert2';
import { HelperService } from 'src/app/service/helper.service';
import { Store } from '@ngrx/store';
import * as _moment from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import { PartyContactMechanisms } from '../../../party/model/party-contact-mechanisms.model';
// for backup/restore setup
import { RegionEntityService } from '../../../common-components/service/region-entity.service';
import { SchoolSearchDistrictsResult } from '../msin-mat-table-districts/model/SchoolSearchDistrictsResult.model';
import { MatTabChangeEvent } from '@angular/material/tabs';

export const MY_FORMATS = {
    parse: {
        dateInput: 'LL'
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};

@Component({
    selector: 'app-edit-school-districts',
    templateUrl: './edit-school-districts.component.html',
    styleUrls: ['./edit-school-districts.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },

        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ]
})
export class EditSchoolDistrictsComponent implements AfterViewInit, OnInit, OnDestroy, ErrorStateMatcher {
    @ViewChild('child') child!: DistrictDropdownComponent;
    //@ViewChild('child2') child2!: RegionDropdownComponent;
    //@ViewChild('child3') child3!: CountyDropdownComponent;
    @ViewChild('tabGroup') tabGroup: any;
    @Output() eventEmitterDistrictcode = new EventEmitter<SchoolDistrict[]>();
    @Output() eventEmitterCountycode = new EventEmitter<County[]>();
    @Output() eventEmitterRegioncode = new EventEmitter<Region[]>();
    @Output() btnClick = new EventEmitter(); // to disable school code buttons when not in edit mode

    selected = new UntypedFormControl('valid', [Validators.required, Validators.pattern('valid')]);
    selectedTab = new UntypedFormControl(0);
    formCtrl = new UntypedFormControl();
    myForm = new UntypedFormArray([new UntypedFormControl('', Validators.required)]);
    selectLabel1: string = 'Select Region(s)';
    selectLabel2: string = 'Select County(s)';
    selectLabel3: string = 'Select School District(s)';
    region!: Region;
    regionCap!: Region;
    district!: SchoolDistrict;
    districts = [];
    resetField: boolean = false;
    selectedCounty: number | undefined;
    myCounty: County;
    myCounties: County[] = [];
    newNumArray: number[] = [];
    myRegions: Region;
    selectedSchoolDistrict: number = 0;
    selectedDistrict: number | undefined;
    schoolDistricts: SchoolDistrict[] = [];
    allSchoolDistricts: SchoolDistrict[] = [];
    allSchoolCounties: County[] = [];
    allSchoolRegions: Region[] = [];
    schoolRegionIds: number[] = [];
    schoolDistrictIds: number[] = [];
    selectedSchoolDistrictIds: number[] = [];
    selectedSchoolDistrictName: string | undefined;
    schoolDistrictName: string = '';
    schoolDistrictCode: string = '';
    schoolDistrictNCES: string = '';
    customCountyLabel: string = "School District's County";
    customRegionLabel: string = "School District's Region";
    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];

    isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
    selectFormControl = new UntypedFormControl('valid', [Validators.required, Validators.pattern('valid')]);

    nativeSelectFormControl = new UntypedFormControl('valid', [Validators.required, Validators.pattern('valid')]);

    matcher = this;

    saveButtonToShow: string = 'generalinfo'; // choices are: generalinfo, contactinfo, schoollocation
    editBtnText: string = 'Edit';
    isUneditable: boolean = true;
    bCancelEdit: boolean = false;
    schoolDistrictID: number = 0;
    selectedRegion: string = '';
    selectedNcesCode: string = '';
    ncesCode: string = '';
    user: User = {};
    partyRoles: PARTYROLE[] = [];
    regions: Region[] = [];
    partyContactMechanisms: PartyContactMechanisms[] = [];
    deletePartyContactMechanisms: PartyContactMechanisms[] = [];
    isLoading: boolean = false;
    loadingCounter: number = 0;
    msg: MsgModel = {};
    userIdChangedMsg: MsgModel = {};

    // init checks
    ncesValid: boolean = false;
    ncesChecking: boolean = false;
    ncesChecked: boolean = false;

    // auth
    canEditSchoolNCES: boolean = false;
    promises: Array<any> = [];

    myControl: any;
    filteredOptions!: Observable<any>;
    private unsubUsername$: Subject<void> = new Subject<void>();
    myError: string = '';
    editSchoolDistrictsForm!: UntypedFormGroup;
    organizationService!: any;
    schoolDistrict: SchoolSearchDistrictsResult;
    schoolDistrictObj: SchoolDistrict;
    schoolDistrictBackup: SchoolDistrict;

    partyId: any = [{}];
    organizationId!: number;
    myOrganization!: ORGANIZATION;
    partyIdNum!: number;
    loadedDistricts$: Observable<boolean>;
    loadedCounties$: Observable<boolean>;

    // backup components
    currentTab: any;
    tabs = [
        {
            'General Info': {
                editing: false,
                control: {},
                editable: true
            },
            'School District Location': {
                editing: false,
                control: {},
                editable: true
            }
        }
    ];

    constructor(
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<EditSchoolDistrictsComponent>,
        @Inject(MAT_DIALOG_DATA) public editData: any,
        private fb: UntypedFormBuilder,
        private userProfileService: UserProfileService,
        private schoolDistrictsAPIService: ApiSchoolDistrictsService,
        private _organizationService: OrganizationService,
        private schoolDistrictService: DistrictEntityService,
        private schoolCountyService: CountyEntityService,
        private schoolRegionService: RegionEntityService,
        private store: Store<AppState>,
        private router: Router,
        private helperService: HelperService
    ) {
        this.organizationService = _organizationService;

        this.editSchoolDistrictsForm = fb.group({
            schoolDName: ['', [Validators.required]],
            //schoolDName2:['', [Validators.required]],
            schoolDNCES: ['', [Validators.required]],
            schoolDCode: ['', [Validators.required]],

            // tab 2 fields
            schoolDRegion: new UntypedFormControl(null),
            schoolDCounty: new UntypedFormControl(null)
        });

        this.schoolDistrictID = this.editData['ID'];
        this.isLoading = true;
        this.loadingCounter = this.loadingCounter + 1;
        this.loadedDistricts$ = schoolDistrictService.loaded$;
        this.loadedCounties$ = schoolCountyService.loaded$;
        this.subscribers();
        this.fnEdit();
    }

    subscribers() {
        let schoolRegionsEntitiesSub = this.schoolRegionService.entities$.subscribe((schoolRegions: Region[]) => {
            this.allSchoolRegions = schoolRegions;
            this.schoolRegionIds = this.allSchoolRegions.length > 0 ? this.allSchoolRegions.map((schoolRegion) => schoolRegion.ID!) : [];
        });

        let schoolDistrictEntitiesSub = this.schoolDistrictService.entities$.subscribe((schoolDistricts: SchoolDistrict[]) => {
            this.allSchoolDistricts = schoolDistricts;
            this.schoolDistrictIds = this.allSchoolDistricts.length > 0 ? this.allSchoolDistricts.map((schoolDistrict) => schoolDistrict.ID!) : [];
        });

        let schoolCountyEntitiesSub = this.schoolCountyService.entities$.subscribe((schoolCounties: County[]) => {
            this.allSchoolCounties = schoolCounties;
        });
    }

    ngOnInit(): void {
        // reinit these starter booleans
        this.ncesValid = false;
        this.ncesChecked = false;
        this.ncesChecking = false;

        this.getUserProfile();

        Promise.all(this.promises).then((res) => {
            this.getPartyRoles();
            ///    this.getRegionsByPartyId();
        });

        // auth - check if allow the user admin operations
        //this.fnCheckCanEditSchoolNCES();

        //     this.myControl = <FormControl>this.editSchoolDistrictsForm.get('username');

        //      this.filteredOptions = this.myControl.valueChanges.pipe(takeUntil(this.unsubUsername$)).subscribe((value: string) => {
        /*         let editUser: User = JSON.parse(JSON.stringify(this.user));
   
             if (editUser.USER_ID !== value) {
                 this.userIdChangedMsg.MSG = '* Your username will be updated. You will be required to login again.';
             } else {
                 this.userIdChangedMsg = {};
             }
       });
   */
    }

    ngAfterViewInit(): void {
        // set school data
        // setTimeout(() => {
        console.log('ngAfterViewInit');
        this.fnSetInitialData();
        //});
        // }, 5000);

        // load party data
        console.log('now loading party data');
        this.organizationId = this.editData['ORGANIZATIONS_ID'];
        this.organizationService.show(this.organizationId).subscribe({
            next: (res: any) => {
                this.myOrganization = res.organization;
                console.log('organization is: ' + Object.entries(this.myOrganization));
                console.log('party ids are: ' + this.myOrganization.PARTIES_ID);
                this.partyId = this.myOrganization.PARTIES_ID;
                this.partyIdNum = parseInt(this.partyId);
                console.log('inbound organization id1 is: ' + this.organizationId);
                console.log('my organization: ' + this.myOrganization.PARTIES_ID);
            },
            error: (err: any) => {
                alert('Error while fetching the records');
                console.log('error while getting organization data');
            }
        });
        console.log('done loading party ids');

        this.editSchoolDistrictsForm = new UntypedFormGroup({
            schoolDName: new UntypedFormControl(null),
            schoolDName2: new UntypedFormControl(null),
            schoolDCode: new UntypedFormControl(null),

            txtSchoolCode: new UntypedFormControl(null),

            // tab 2 fields
            myRegion: new UntypedFormControl(null),
            myDistrict: new UntypedFormControl(null),
            myCounty: new UntypedFormControl(null),
            schoolDNCES: new UntypedFormControl(null)
        });
    }

    districtsSelected(districts: SchoolDistrict[]) {
        var editDistrict: any;
        if (districts[0] && this.chosenCounties[0]?.COUNTY_NAME != undefined) {
            editDistrict = this.getSpecificDistrict(districts[0].ID);
        }
    }

    countiesSelected(counties: County[]) {
        this.eventEmitterCountycode.emit(counties);
        this.ncesCode = '';
        this.selectedNcesCode = '';
    }

    regionEventEmitter(lstRegion: Region[]) {
        this.loadingCounter = this.loadingCounter + 1;
        if (this.loadingCounter > 2 && this.chosenCounties[0]?.COUNTY_NAME == undefined) {
            this.selectedSchoolDistrict = 0;
        }
        this.ncesCode = '';
        this.selectedNcesCode = '';
    }

    fnCancelEdit() {
        this.bCancelEdit = !this.bCancelEdit;
        Swal.fire({
            title: 'Are you sure you want to stop editing and discard all changes made?',
            showDenyButton: true,
            showConfirmButton: false,
            showCancelButton: true,
            denyButtonText: `Confirm`
        }).then((result) => {
            if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info');
                this.isUneditable = !this.isUneditable;
                this.editBtnText = 'Edit';
                this.fnReset();
            }
        });
    }

    fnEdit() {
        this.myError = '';
        this.isUneditable = !this.isUneditable;
        if (!this.isUneditable) {
            this.editBtnText = 'Editing...';
            this.bCancelEdit = true;

            this.schoolDistrictBackup = { ...this.schoolDistrict };
            console.log(this.schoolDistrictBackup);
            console.log('is the backup just saved');
        } else {
            this.bCancelEdit = false;
            this.editBtnText = 'Edit';
        }
    }

    fnSetInitialData() {
        console.log('setting initial school data');
        console.log(this.editData);

        this.schoolDistrictID = this.editData['ID'];
        console.log('incoming id was: ');
        console.log(this.schoolDistrictID);
        this.schoolDistrictsAPIService.show(this.schoolDistrictID).subscribe((res) => {
            console.log('thisSchoolDistrict: ');
            console.log(res);
            this.schoolDistrict = res.schoolDistrict;
            this.schoolDistrictBackup = { ...this.schoolDistrict };
            console.log(this.schoolDistrictBackup);
            console.log('is the backup just saved');
            console.log(this.schoolDistrictBackup);

            this.schoolDistrictNCES = this.schoolDistrict.NCESDist || '';
            this.schoolDistrictName = this.schoolDistrict.DISTRICTS || '';
            this.schoolDistrictCode = this.schoolDistrict.CODE || '';
            this.regions = this.editData['REGIONS'];
            var translateCounty = Object.values(this.editData['COUNTy']).toString().split(',');
            this.ncesCode = this.schoolDistrictNCES;

            this.chosenRegions = [];
            let newRegion = new Region();
            newRegion.ID = this.editData['REGIONS']?.ID;
            this.chosenRegions.push(newRegion);

            this.chosenCounties = [];
            let newCounty = new County();
            newCounty.ID = this.editData['COUNTy']?.ID;
            this.chosenCounties.push(newCounty);

            this.isLoading = false;

            this.fnCheckNCESDistrictCode();
            // this.schoolDistrictBackup = { ...this.schoolDistrict };
            // backup for screenBackup save functionality
            /*this.schoolDistrictBackup = JSON.parse(JSON.stringify(this.schoolDistrict));
        console.log("new backup set for school");
        console.log(this.schoolDistrictBackup);
        */
        });
    }

    fnReset() {
        setTimeout(() => {
            this.fnSetInitialData();
        }, 1000);
    }

    getPartyRoles() {
        //console.log("getting party roles for user:" + Object.entries(this.user))
        this.userProfileService.getPartyRoles(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
            if (res?.partyRoles) {
                this.partyRoles = res.partyRoles;
                console.log('got party roles:' + res.partyRoles);
            }
        });
    }

    getRegionsByPartyId() {
        this.userProfileService.getRegionsByPartyId(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
            if (res?.regions) {
                this.regions = res.regions;
            }
        });
    }

    // for Auth
    fnCheckCanEditSchoolNCES() {
        // until sec roles have been implemented, we will set this as true
        this.canEditSchoolNCES = true;
    }

    catchSubmitError(err: any) {
        console.log('submit edits caught error:' + err);
        this.myError = 'Error during submit:' + err;
    }

    closeRecord() {
        if (this.isUneditable) {
            console.log('now closing record');

            this.dialogRef.close();
        } else {
            Swal.fire({
                title: 'Are you sure you want to stop editing and discard all changes made?',
                showDenyButton: true,
                showConfirmButton: false,
                showCancelButton: true,
                denyButtonText: `Confirm`
            }).then((result) => {
                console.log('now closing way');
                if (result.isDenied) {
                    Swal.fire('Changes are not saved', '', 'info');
                    // this.isUneditable = !this.isUneditable;
                    this.editBtnText = 'Edit';
                    this.fnReset();
                    console.log('now closing way a');
                    this.dialogRef.close();
                }
                if (result.isConfirmed) {
                    console.log('save complete');
                    console.log('now closing way b');
                    this.dialogRef.close();
                } else {
                    console.log('now closing way c');
                    console.log('save complete');
                    // do nothing except close popup swal confirmation
                }
            });
        }
    }

    ngOnDestroy(): void {
        this.unsubUsername$.next();
        this.unsubUsername$.complete();
    }

    getUserProfile() {
        let deferred = new Promise((resolve, reject) => {
            this.userProfileService.getMyProfile().subscribe((res) => {
                if (res?.user) {
                    this.user = res.user;

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });
        this.promises.push(deferred);
    }

    fnCheckNCESDistrictCode(evt?: Event) {
        this.ncesValid = false;
        console.log('now checking ncesdistrictcode for:' + this.ncesCode);
        if (!this.ncesCode) {
            console.log('nces code had blank inputs');

            this.myError = 'Error checking NCES District Code:  ncesCode was blank for this school.';
            this.ncesValid = false;
        } else {
            this.schoolDistrictsAPIService.checkDistrictNCES(parseInt(this.ncesCode), this.schoolDistrictID).subscribe({
                next: (res: any) => {
                    console.log('ncesCodeCheck returned: ');
                    console.log(Object.entries(res.msg));
                    if (res.msg['SUCCESS'] == false) {
                        this.myError = 'Error checking nces district Code:' + res.msg['MSG'];
                        this.ncesValid = false;
                        this.ncesChecking = false;
                    } else {
                        this.ncesValid = true;
                        this.ncesChecking = false;
                        this.ncesChecked = true;
                    }
                },
                error: (err: any) => {
                    this.myError = 'Error checking NCES District Code, please try again.';
                    this.ncesValid = false;
                    this.ncesChecking = false;
                }
            });
        }
    }

    fnSetSaveButton($event: MatTabChangeEvent) {
        var inStr: string = '';
        switch ($event.index) {
            case 0:
                inStr = 'generalinfo';
                break;
            case 1:
                inStr = 'schooldistrictlocation';
                break;
            default:
                inStr = 'generalinfo';
                break;
        }
        this.saveButtonToShow = inStr;
    }

    pad(num: number) {
        return ('00' + num).slice(-2);
    }

    fnSaveGeneralInfo() {
        console.log('saving general info');
        this.myError = ''; // this needs to be cleared each time prior to a new save

        let inSchoolID: number = this.schoolDistrictID; // editSchoolDistrictsForm.controls['ID'].value; //this.organizationId; //
        let inOrgId: number = this.organizationId;
        let inSchoolDistrictName: string = this.editSchoolDistrictsForm.controls['schoolDName'].value;
        let inSchoolDistrictNCES: string = this.editSchoolDistrictsForm.controls['schoolDNCES'].value;
        let inSchoolDistrictCode: string = this.editSchoolDistrictsForm.controls['schoolDCode'].value;
        let inTxtSchoolCode: string = this.editSchoolDistrictsForm.controls['txtSchoolCode'].value;

        if (inSchoolDistrictName) inSchoolDistrictName = inSchoolDistrictName?.trim();
        if (inSchoolDistrictNCES) inSchoolDistrictNCES = inSchoolDistrictNCES?.trim();

        let editSchoolDistrict: SchoolDistrict = new SchoolDistrict();
        if (inSchoolID != null) {
            editSchoolDistrict.ID = inSchoolID;
            this.schoolDistrict.ID = inSchoolID;
        }
        if (inOrgId != null) {
            editSchoolDistrict.ORGANIZATIONS_ID = inOrgId;
            this.schoolDistrict.ORGANIZATIONS_ID = inOrgId;
        }
        if (inSchoolDistrictName != null) {
            editSchoolDistrict.DISTRICTS = inSchoolDistrictName;
            this.schoolDistrict.DISTRICTS = inSchoolDistrictName;
        }
        if (inSchoolDistrictNCES != null) {
            editSchoolDistrict.NCESDist = inSchoolDistrictNCES;
            this.schoolDistrict.NCESDist = inSchoolDistrictNCES;
        }
        if (inSchoolDistrictCode != null) {
            editSchoolDistrict.CODE = inSchoolDistrictCode;
            this.schoolDistrict.CODE = inSchoolDistrictCode;
        }

        Swal.fire({
            title: 'Are you sure you want to save?',
            showDenyButton: false,
            showConfirmButton: true,
            showCancelButton: true,
            denyButtonText: ``
        }).then((result) => {
            if (result.isConfirmed && this.myError == '') {
                console.log('now saving GeneralInfo with:' + this.schoolDistrict);

                this.schoolDistrictsAPIService.updateSchoolDistrictsGeneralInfo(this.schoolDistrict).subscribe({
                    next: (res: any) => {
                        //console.log("checking api res message:")
                        //console.log(res)
                        //console.log(res.editSchool)
                        if (!res.msg['SUCCESS']) {
                            this.isUneditable = false;
                            this.bCancelEdit = true;
                            this.myError = res.msg['MSG'];
                        } else {
                            this.isUneditable = true;
                            this.bCancelEdit = false;
                            this.editBtnText = 'Edit';
                        }
                    },
                    error: (err: any) => {
                        console.log('error while updating school data: ' + Object.entries(err));
                    }
                });
            } else {
                console.log('errored out so we are not saving');
            }
        });
    }

    fnSaveSchoolDistrictsLocation() {
        console.log('saving school districts location');

        /*console.log("incoming counties:" + inCounties.trim())
    console.log("incoming regions:" + inRegions.toString())
    */
        var editRegion: any;
        editRegion = this.chosenRegions[0];

        var editCounty: any;
        editCounty = this.chosenCounties[0];

        Swal.fire({
            title: 'Are you sure you want to save?',
            showDenyButton: false,
            showConfirmButton: true,
            showCancelButton: true,
            denyButtonText: ``
        }).then((result) => {
            if (result.isConfirmed) {
                console.log('result is confirmed');
                let params: any;
                let iContactMechIndex = 0;

                this.schoolDistrict.REGIONS = editRegion['CODE'];
                console.log('schoolDistrict Regions to save');
                console.log(this.schoolDistrict.REGIONS);
                console.log(editRegion);
                console.log(editCounty);
                this.schoolDistrict.COUNTy = editCounty;
                this.countiesSelected(editCounty);

                // set back school district nces after it was reset by selecting county/district
                //let inSchoolDistrictNCES: string = this.editSchoolDistrictsForm.controls['schoolDistrictNCES'].value;

                //this.ncesCode = inSchoolDistrictNCES;
                console.log('backup being saved:');
                console.log(this.schoolDistrictBackup);
                let data: any;
                data = {
                    schoolDistrict: this.schoolDistrict,
                    schoolDistrictBackup: this.schoolDistrictBackup
                };

                console.log('now saving with data');
                console.log(data);

                this.schoolDistrictsAPIService
                    .updateSchoolDistrictsLocation(data) // , this.school
                    .subscribe({
                        next: (res: any) => {
                            this.isUneditable = true;
                            this.bCancelEdit = false;
                            this.editBtnText = 'Edit';
                            console.log('save done');
                            console.log(res);
                        },
                        error: (err: any) => {
                            console.log('error while updating school data: ' + Object.entries(err));
                        }
                    });

                this.schoolDistrictsAPIService
                    .show(this.schoolDistrictID) // , this.school
                    .subscribe({
                        next: (res: any) => {
                            this.isUneditable = true;
                            this.bCancelEdit = false;
                            this.editBtnText = 'Edit';
                            //console.log("show done")
                            //console.log(res)
                        },
                        error: (err: any) => {
                            console.log('error while updating school district data: ' + Object.entries(err));
                        }
                    });
            }
        });
    }

    getSpecificDistrict(id: number): SchoolDistrict | null {
        for (var i = 0; i < this.allSchoolDistricts.length; i++) {
            if (this.allSchoolDistricts[i].ID == id) {
                return this.allSchoolDistricts[i];
            }
        }
        return null;
    }

    getSpecificRegion(id: number): Region | null {
        for (var i = 0; i < this.allSchoolRegions.length; i++) {
            if (this.allSchoolRegions[i].ID) {
                if (this.allSchoolRegions[i].ID == id) {
                    return this.allSchoolRegions[i];
                }
            }
        }
        return null;
    }

    getSpecificCounty(id: number): County | null {
        for (var i = 0; i < this.allSchoolCounties.length; i++) {
            if (this.allSchoolCounties[i].ID == id) {
                return this.allSchoolCounties[i];
            }
        }
        return null;
    }
}
